import { render } from "./CheckBox.vue?vue&type=template&id=30cd1aa1&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=30cd1aa1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30cd1aa1"

export default script